<mat-datepicker-toggle [fxHide]="chooserBarType!=='DATE'" matPrefix [for]="picker"></mat-datepicker-toggle>
<mat-datepicker [fxHide]="chooserBarType!=='DATE'" #picker></mat-datepicker>
<mat-chip-list #chipList aria-label="Choose" cdkDropList cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)" [selectable]="true">
    <mat-chip *ngFor="let item of selectedItems" [selectable]="true" [removable]="true" (removed)="removeItem(item)"
        (click)="chip.selected ? chip.deselect() : chip.select()" #chip="matChip" cdkDrag>
        {{item.label}}
        <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <input *ngIf="chooserBarType!=='DATE'" [placeholder]="placeholder" #itemInput [formControl]="itemCtrl" [type]="inputType"
        [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="onAdd($event)"
        [disabled]="maxAllowed !== -1 && selectedItems.length >= maxAllowed" matInput>
    <input *ngIf="chooserBarType==='DATE'" [placeholder]="placeholder" #itemInput [formControl]="itemCtrl"
        [matDatepicker]="picker" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="onAdd($event)"
        [disabled]="maxAllowed !== -1 && selectedItems.length >= maxAllowed" (dateChange)="onSelected($event)" hidden>
    <div [fxHide]="!ordered">
        <button mat-icon-button (click)="moveFirst()">
            <mat-icon>first_page</mat-icon>
        </button>
        <button mat-icon-button (click)="movePrevious()">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <button mat-icon-button (click)="moveNext()">
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button (click)="moveLast()">
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
</mat-chip-list>
<mat-autocomplete [fxHide]="chooserBarType!=='SELECT'" #auto="matAutocomplete" (optionSelected)="onSelected($event)"
    panelWidth="300">
    <mat-option *ngFor="let item of filteredItems | async" [value]="item">
        {{item.label}}
    </mat-option>
</mat-autocomplete>